<template>
  <div class="categories-filter">
    <div v-if="!isLeft" class="categories-filter__arrow left" @click="prevOnClick()">
      <i class="icon-arrow-left xs"></i>
    </div>
    <div
      ref="categories"
      class="categories-filter__categories"
      @mousedown="dragging = true"
      @touchstart="dragging = true"
    >
      <div
        v-for="category in categories"
        :key="category.code"
        class="transition-all category"
        :class="{ 'category--selected': category.selected }"
        @mousedown="pretendClick = true"
        @mouseup="pretendClick && toggle(category)"
        @touchend="pretendClick = true"
      >
        <i :class="'icon-' + category.code" class="xs"></i>
        <span class="category__title">{{ category.name }}</span>
        <i
          class="transition-all category__selection icon-check xs"
          :class="category.selected ? 'category__selection' : 'category__unselection'"
        ></i>
      </div>
    </div>
    <div v-if="!isRight" class="categories-filter__arrow right" @click="nextOnClick()">
      <i class="icon-arrow-right xs"></i>
    </div>
  </div>
</template>

<script>
import { scrollEffect } from '@/infrastructure/Utils'
export default {
  name: 'CategoriesFilter',
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      pretendClick: false,
      scrollIncrement: 200,
      scrollX: 0,
      maxScroll: 0,
      dragging: false
    }
  },
  computed: {
    isLeft() {
      return this.scrollX === 0
    },
    isRight() {
      return this.scrollX >= this.maxScroll
    }
  },
  created() {
    window.onresize = () => this._calculateMaxScroll()
    window.onmousemove = event => this._onDragging(event.movementX)
    let previousTouch
    window.addEventListener('touchmove', e => {
      const touch = e.touches[0]
      if (previousTouch) {
        const movementX = touch.pageX - previousTouch.pageX
        this._onDragging(movementX)
      }
      previousTouch = touch
    })
    window.ontouchend = () => {
      this.dragging = false
      previousTouch = null
    }
    window.onmouseup = () => {
      this.dragging = false
    }
  },
  updated() {
    this.maxScroll = this.$refs.categories.scrollWidth - this.$refs.categories.clientWidth
  },
  methods: {
    prevOnClick() {
      this._moveScroll('previous', this.scrollIncrement, scrollEffect())
    },
    nextOnClick() {
      this._moveScroll('next', this.scrollIncrement, scrollEffect())
    },
    toggle(category) {
      if (!this.pretendClick) {
        return
      }

      if (category.selected) {
        this.$emit('unselect', category)
      } else {
        this.$emit('select', category)
      }
    },
    _calculateMaxScroll() {
      this.maxScroll = this.$refs.categories.scrollWidth - this.$refs.categories.clientWidth
    },
    _onDragging(movementX) {
      this.pretendClick = false

      if (this.dragging) {
        if (movementX > 1) {
          this._moveScroll('previous', Math.abs(movementX), 'auto')
        } else if (movementX < 1) {
          this._moveScroll('next', Math.abs(movementX), 'auto')
        }
      }
    },
    _moveScroll(direction, increment, effect) {
      let newScrollX, distance
      if (direction === 'previous') {
        distance = this.scrollX - increment
        newScrollX = distance > 0 ? distance : 0
      } else {
        distance = this.scrollX + increment
        newScrollX = distance < this.maxScroll ? distance : this.maxScroll
      }

      this.scrollX = newScrollX
      this.$refs.categories.scroll({
        left: this.scrollX,
        top: 0,
        behavior: effect
      })
    }
  }
}
</script>

<style scoped lang="scss">
.categories-filter {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;

  &__categories {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    column-gap: 1.2rem;

    @media (max-width: media('tablet-l')) {
      margin: 0 0 0 15px;
    }
  }

  &__arrow {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    z-index: zindex('cover-content');

    &.left {
      left: 0;
      padding-right: 4.5rem;
      background: #ffffff;
      background: linear-gradient(-90deg, #ffffff00 0%, #ffffff 45%, #ffffff 100%);
    }

    &.right {
      right: 0;
      padding-left: 4.5rem;
      background: #ffffff;
      background: linear-gradient(90deg, #ffffff00 0%, #ffffff 45%, #ffffff 100%);
    }
  }

  @media (max-width: media('tablet-l')) {
    &__arrow {
      display: none;
      padding: 0 1.2rem;
    }
  }
}

.category {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0.8rem 1.2rem;
  border: solid 1px #d4d4d4;
  border-radius: 10rem;
  cursor: pointer;

  i.category__selection {
    opacity: 0;
  }

  & > * + * {
    margin-left: 1rem;
  }

  &:hover {
    border: solid 1px black;
  }

  &--selected {
    border: solid 1px black;

    i.category__selection {
      opacity: 1;
    }
  }

  &__title {
    white-space: nowrap;
  }

  &__selection {
    color: crimson;
  }

  &__unselection {
    color: #eeeeee;
  }
}
</style>
